'use client';

/**
 * Global error boundary (T6 USM).
 */
import { useEffect } from 'react';
import { PlaceholderState } from '@brisa/ui/placeholder-state';
import { logger } from '@brisa/shared/logger';

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  useEffect(() => {
    logger.error('[brisa] unhandled error', { message: error.message, digest: error.digest });
  }, [error]);

  return (
    <PlaceholderState
      variant="app"
      eyebrow="ALGO QUEBROU"
      lead="FALHA NO SERVIÇO."
      body="Nossa equipe foi notificada. Tente novamente em alguns instantes."
    />
  );
}
